import React from 'react';
import ReactDOM from 'react-dom';
import { translate, Interpolate } from 'react-i18next';

import LoginActions from 'actions/LoginActions';
import UIStatusDialog from 'components/UIStatusDialog';
import ReCAPTCHA from 'vendor/react-recaptcha.js';
import Popover from 'components/popover/Popover.js';
import UserActions from 'actions/UserActions.js';

class LoginView extends React.Component {
  constructor(props) {
    super(props);

    this.onLoginError = this.onLoginError.bind(this);
    this.tokenExpiredError = this.tokenExpiredError.bind(this);
    this.tokenDisappearError = this.tokenDisappearError.bind(this);
    this.showLoginError = this.showLoginError.bind(this);
    this._forgotPasswordClick = this._forgotPasswordClick.bind(this);
    this._onClosePopover = this._onClosePopover.bind(this);
    this._onCloseLockedPopover = this._onCloseLockedPopover.bind(this);
    this._onHandleClosePopover = this._onHandleClosePopover.bind(this);
    this._correctCaptcha = this._correctCaptcha.bind(this);
    this._emailInput = this._emailInput.bind(this);
    this._onSubmitPasswordRequest = this._onSubmitPasswordRequest.bind(this);

    this.loginAttemptCount = 0;

    this.state = {
      dirty: false,
      popOverActive: false,
      popTarget: null,
      lockedPopOverActive: false,
      lockedPopTarget: null,
      email: '',
      rememberMe: false,
      forgotCaptchaVerified: false,
      forgotEmailVerified: false,
      userEmail: '',
      passwordReset: false,
      invalidForgotEmail: false,
      status: {
        message: '',
        title: '',
        status: 'hide',
      },
    };
  }

  componentDidMount() {
    if (localStorage.rememberMe && localStorage.email) {
      this.setState({
        email: localStorage.email,
        rememberMe: true,
        dirty: false,
      });
    }
    document.addEventListener('popover:closed', this._onHandleClosePopover, this);
    if (this.props.route && this.props.route.store) {
      LoginStore.on('login:error', this.onLoginError);
      LoginStore.on('login:tokenUnauthorized', this.tokenExpiredError);
      LoginStore.on('login:tokenDisappear', this.tokenDisappearError);

      UserStore.on(
        'user:reset:password:success',
        function (collection, response) {
          this.setState({
            passwordReset: true,
          });
        },
        this,
      );

      UserStore.on(
        'user:reset:password:error',
        function (error) {
          if (error.status == 404) {
            this.setState({
              invalidForgotEmail: true,
            });
          } else {
            const message = JSON.parse(error.responseText);
            this.showLoginError(this.props.t('LoginView.invalid_credentials'), message.error_message);
          }
        },
        this,
      );
    }
  }

  componentWillUnmount() {
    this.loginAttemptCount = 0;
    LoginStore.off(null, null, this);
    AccountStore.off(null, null, this);
    UserStore.off(null, null, this);
    UserStore.off(null, null, this);
    document.removeEventListener('popover:closed', this._onHandleClosePopover, this);
  }

  _onSubmitPasswordRequest() {
    UserActions.resetPassword(this.state.userEmail);
  }

  _emailInput(e) {
    if (Utils.validateEmail(e.target.value)) {
      this.setState({
        forgotEmailVerified: true,
        userEmail: e.target.value,
        invalidForgotEmail: false,
      });
    } else {
      this.setState({
        forgotEmailVerified: false,
        userEmail: null,
        invalidForgotEmail: false,
      });
    }
  }

  _correctCaptcha() {
    const v = window.grecaptcha.getResponse();
    if (v.length == 0) {
      this.setState({ forgotCaptchaVerified: false });
    } else {
      this.setState({ forgotCaptchaVerified: true });
    }
  }

  _onCloseLockedPopover() {
    this.setState({
      lockedPopOverActive: false,
      lockedPopTarget: null,
    });
  }

  _onClosePopover() {
    $('#login').removeClass('anim__forget__password');
    window.grecaptcha.reset();
    this.setState({
      popOverActive: false,
      popTarget: null,
      passwordReset: false,
      userEmail: null,
      invalidForgotEmail: false,
      forgotCaptchaVerified: false,
    });

    // Clear the value of the input (which is not a react input)
    $('#forgot-field-id').val("");
  }

  _onHandleClosePopover(e) {
    if (ReactDOM.findDOMNode(this).contains(e.popOver)) {
      this._onClosePopover();
    }
  }

  _forgotPasswordClick(e) {
    $('#login').addClass('anim__forget__password');
    this.setState({
      popOverActive: !this.state.popOverActive,
      popTarget: e.target,
    });
  }

  onSubmitLogin(e) {
    const { email, password } = this.state;
    const isRemembering = this.state.rememberMe;

    this.setState({
      invalidForgotEmail: false,
      status: {
        message: '',
        status: 'hide',
        title: '',
      },
    });

    if (isRemembering) {
      localStorage.email = this.state.email;
      localStorage.rememberMe = true;
    }

    if (LoginActions) {
      LoginActions.postLogin(email, password);
    }
    e.preventDefault();
  }

  onInputChange(e) {
    const email = e.target.value;
    this.setState({
      invalidForgotEmail: false,
      dirty: true,
      email,
      status: this.clearStatusIfDisplayed5sec(),
    });
  }

  onPasswordChange(e) {
    const password = e.target.value;
    this.setState({
      invalidForgotEmail: false,
      password,
      status: this.clearStatusIfDisplayed5sec(),
    });
  }

  // this is in attempts to defeat autofill from clearing the status
  // immediately after signing the user out and return to login
  clearStatusIfDisplayed5sec() {
    const clearedStatus = {
      message: '',
      status: 'hide',
      title: '',
    };

    // lastSet is probably undefined.
    // it's only set in the case of token expiration
    if (!this.state.status.lastSet) {
      return clearedStatus;
    }

    if (this.state.status.lastSet < Date.now() - 2000) {
      return clearedStatus;
    }

    return this.state.status;
  }

  showLoginError(title, message) {
    this.setState({
      status: {
        message: message,
        status: 'error',
        title: title
      }
    });
  }

  onLoginError(error) {
    // TODO: commented out this increment so the lockedPopOver never opens.
    //      the backend needs an endpoint for locking an account. Once that
    //      is created that will have to be called at this point to actually
    //      lock the user out.
    // this.loginAttemptCount++

    Utils.deleteCookie('authToken');
    localStorage.removeItem('coreUser');
    localStorage.removeItem('lastUserFetch');

    if (this.loginAttemptCount >= 5) {
      this.loginAttemptCount = 0;

      this.setState({
        lockedPopOverActive: true,
        lockedPopTarget: ReactDOM.findDOMNode(this),
      });

      return;
    }

    let message;
    try {
      message = JSON.parse(error.responseText);
    } catch (e) {
      message = this.props.t('LoginView.login_error');
    }

    if (error.status == 500 || typeof message.error_message === 'undefined') {
      this.showLoginError(this.props.t('LoginView.error'), this.props.t('LoginView.something_went_wrong'));
    } else {
      this.showLoginError(this.props.t('LoginView.invalid_credentials'), message.error_message);
    }
  }

  tokenExpiredError() {
    this.setState({
      status: {
        message: this.props.t('LoginView.session_has_expired'),
        status: 'error',
        title: this.props.t('LoginView.session_expired'),
        lastSet: Date.now(),
      },
    });
  }

  tokenDisappearError() {
    this.setState({
      status: {
        message: this.props.t('LoginView.token_has_expired'),
        status: 'error',
        title: this.props.t('LoginView.session_expired'),
        lastSet: Date.now(),
      },
    });
  }

  handleRememberMe(e) {
    const { checked } = e.target;
    if (checked) {
      localStorage.email = this.state.email;
      localStorage.rememberMe = true;
      this.setState({ rememberMe: true });
    } else {
      localStorage.email = '';
      localStorage.rememberMe = false;
      this.setState({ rememberMe: false });
    }
  }

  render() {
    const { loginErrorMessage, passwordErrorMessage } = this.props;

    const signUpCopy = [];
    let loginFooter = [];
    switch (window.EmployeeWeb.ENVConfig.brand) {
      case 'makeshift':
        signUpCopy.push(
          <Interpolate 
            key={1}
            i18nKey="LoginView.are_you_an_employer" 
            link={<a href={window.EmployeeWeb.ENVConfig.sign_up_link} target="_blank">{this.props.t('LoginView.sign_up')}</a>} 
            brandName={window.EmployeeWeb.ENVConfig.brand_name}
          />
        );
        loginFooter.push(
          <div key={1}>
            <ul>
              {window.EmployeeWeb.ENVConfig.terms_link &&
                <li><a target="_blank" href={window.EmployeeWeb.ENVConfig.terms_link}>{this.props.t('LoginView.terms_of_use')}</a></li>
              }
              {window.EmployeeWeb.ENVConfig.privacy_link &&
                <li><a target="_blank" href={window.EmployeeWeb.ENVConfig.privacy_link}>{this.props.t('LoginView.privacy_policy')}</a></li>
              }
            </ul>
            <p>&copy; {new Date().getFullYear()} MakeShift. {this.props.t('LoginView.all_rights_reserved')}</p>
          </div>
        );
        break;
      case 'cerner':
        loginFooter.push(
          <ul key={2}>
            {window.EmployeeWeb.ENVConfig.terms_link &&
              <li><a target="_blank" href={window.EmployeeWeb.ENVConfig.terms_link}>{this.props.t('LoginView.terms_of_use')}</a></li>
            }
            {window.EmployeeWeb.ENVConfig.privacy_link &&
              <li><a target="_blank" href={window.EmployeeWeb.ENVConfig.privacy_link}>{this.props.t('LoginView.privacy_policy')}</a></li>
            }
          </ul>
        );
        break;
      case 'adp':
        loginFooter.push(
          <div key={3}>
            <ul>
              <li><a target="_blank" href={window.EmployeeWeb.ENVConfig.privacy_link}>{this.props.t('LoginView.privacy')}</a></li>
              <li><a target="_blank" href={window.EmployeeWeb.ENVConfig.terms_link}>{this.props.t('LoginView.legal')}</a></li>
            </ul>
            <p>{this.props.t('LoginView.copyright_adp', { year: new Date().getFullYear() })}</p>
          </div>
        );
        break;
      default: undefined;
    }

    let grep;
    if (typeof window.grecaptcha !== 'undefined') {
      grep = window.grecaptcha;
    }

    let forgotDisabled = 'disabled';
    if (this.state.forgotCaptchaVerified && this.state.forgotEmailVerified) {
      forgotDisabled = '';
    }

    let forgotErrorMessage = '';
    let forgetErrorFieldClasses = 'field__input';
    let forgotErrorMessageClass = 'error-message hide';
    if (this.state.invalidForgotEmail) {
      forgotErrorMessage = this.props.t('LoginView.email_not_associated');
      forgotErrorMessageClass = 'error-message';
      forgetErrorFieldClasses = 'field__input error';
    }

    return (
      <section id="login">
        <div className="login-top">
          <img src={`/images/brands/${Utils.getCurrentBrand()}/login-logo.png`} />
        </div>

        {window.EmployeeWeb.ENVConfig.brand !== 'adp' &&
          <div>
            <form>
              <div className="field">
                <label htmlFor="username">{this.props.t('LoginView.email')}</label>
                <input
                  name="email"
                  onChange={this.onInputChange.bind(this)}
                  value={this.state.email}
                  type="email"
                />
                <div className="message">{loginErrorMessage}</div>
              </div>

              <div>
                <label htmlFor="password">{this.props.t('LoginView.password')}</label>
                <input name="password" onChange={this.onPasswordChange.bind(this)} type="password" />
                <div className="message">{passwordErrorMessage}</div>
              </div>

              <div className="remember-me">
                <input
                  onChange={this.handleRememberMe.bind(this)}
                  value={this.state.rememberMe}
                  checked={this.state.rememberMe}
                  type="checkbox"
                  id="remember-me"
                />
                <label htmlFor="remember-me">{this.props.t('LoginView.remember_me')}</label>
              </div>

              <UIStatusDialog status={this.state.status} />

              <button
                onClick={this.onSubmitLogin.bind(this)}
                className="btn btn-center btn-link-color-dark sign-in-button"
              >
                {this.props.t('LoginView.sign_in')}
              </button>
              <a href="#" className="forget-password" onClick={e => this._forgotPasswordClick(e)}>
                {this.props.t('LoginView.forgot_password')}
              </a>
              {
                // BambooSSO login button
                // window.EmployeeWeb.ENVConfig.brand === 'makeshift' &&
                // <div>
                //   <div className="third-party-sign-in">
                //     <span className="sign-in-with-text">Or Sign In With</span>
                //   </div>
                //
                //   <div className="bamboo-login-container">
                //     <a className="btn flat-btn bamboo-login" href={window.EmployeeWeb.ENVConfig.bamboo_sso_url}></a>
                //   </div>
                // </div>
              }
            </form>

            <Popover
              className="forgot-popover"
              active={this.state.popOverActive}
              popTarget={this.state.popTarget}
              onHide={e => this._onClosePopover(e)}
            >
              <h3>{this.props.t('LoginView.forgot_password')}?</h3>
              <div
                id="form-view"
                className={
                  !Utils.isNotDefined(this.state.passwordReset) && this.state.passwordReset
                    ? 'hide'
                    : 'show'
                }
              >
                <p>{this.props.t('LoginView.reset_password_instructions', { brandName: window.EmployeeWeb.ENVConfig.brand_name })}</p>

                <form id="forgot-password-form">
                  <div className="field">
                    <label className="field__label" htmlFor="forgot-field-id">
                      {this.props.t('LoginView.email')}
                    </label>
                    <input
                      type="text"
                      id="forgot-field-id"
                      className={forgetErrorFieldClasses}
                      placeholder={this.props.t('LoginView.email_address')}
                      onInput={this._emailInput}
                      value={this.state.userEmail}
                    />
                    <p className={forgotErrorMessageClass}>{forgotErrorMessage}</p>
                  </div>

                  <label className="field__label">{this.props.t('LoginView.security')}</label>
                  <ReCAPTCHA
                    ref="recaptcha"
                    sitekey="6LeAdRYUAAAAANqswN2Si17uwVlzYTa2wG0vyHXk"
                    onChange={this._correctCaptcha}
                    theme="light"
                    type="image"
                    tabindex={0}
                    size="normal"
                    grecaptcha={grep || null}
                  />

                  <div className="btn-group pull--right">
                    <button
                      className="button button--inline"
                      id="forgot-password-button"
                      type="button"
                      onClick={this._onClosePopover}
                    >
                      {this.props.t('LoginView.cancel')}
                    </button>
                    <button
                      className="button button--recommended button--inline"
                      type="button"
                      disabled={forgotDisabled || !this.state.userEmail}
                      onClick={this._onSubmitPasswordRequest}
                    >
                      {this.props.t('LoginView.get_new_password')}
                    </button>
                  </div>
                </form>
              </div>
              <div
                id="feedback-view"
                className={
                  Utils.isNotDefined(this.state.passwordReset) && !this.state.passwordReset
                    ? 'hide'
                    : 'show'
                }
              >
                <p>{this.props.t('LoginView.reset_password_instructions_sent', { email: this.state.userEmail })}</p>
                <div className="btn-group pull--center">
                  <button
                    className="button button--inline"
                    id="forgot-password-ok-button"
                    type="button"
                    onClick={this._onClosePopover}
                  >
                    {this.props.t('LoginView.ok')}
                  </button>
                </div>
              </div>
            </Popover>

            <Popover
              className="account-locked-popover"
              active={this.state.lockedPopOverActive}
              popTarget={this.state.lockedPopTarget}
              onHide={e => this._onCloseLockedPopover(e)}
            >
              <h3>{this.props.t('LoginView.warning')}</h3>
              <p>
                {this.props.t('LoginView.account_locked_instructions')}
              </p>
              <div className="btn-group pull--center">
                <button
                  className="button button--inline"
                  id="locked-account-ok-button"
                  type="button"
                  onClick={this._onCloseLockedPopover}
                >
                  {this.props.t('LoginView.ok')}
                </button>
              </div>
            </Popover>

            <div className="login-bottom">{signUpCopy}</div>
          </div>
        }

        {window.EmployeeWeb.ENVConfig.brand === 'adp' &&
          <div className="adp-login-container">
            <UIStatusDialog status={this.state.status} />
            <a className="btn adp-login" href={window.EmployeeWeb.ENVConfig.adp_sso_url}>
              {this.props.t('LoginView.employee_sign_in')}
            </a>
          </div>
        }

        <div className="login-footer">
          {loginFooter}
        </div>
      </section>
    );
  }
}

export default translate()(LoginView);
